"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMainVideoId = exports.getFeaturedVideoId = exports.getSelectedVideoIdFromStore = void 0;
var reselect_1 = require("reselect");
var lodash_1 = require("lodash");
var channels_1 = require("../../common/selectors/channels");
var getSelectedVideoIdFromStore = function (state) { return state.selectedVideoId; };
exports.getSelectedVideoIdFromStore = getSelectedVideoIdFromStore;
exports.getFeaturedVideoId = (0, reselect_1.createSelector)([channels_1.getChannelForWidget], function (channel) { return (0, lodash_1.get)(channel, 'featuredItem'); });
var getFirstVideoFromStore = function (state) { return state.firstChannelVideoId; };
exports.getMainVideoId = (0, reselect_1.createSelector)([exports.getSelectedVideoIdFromStore, exports.getFeaturedVideoId, getFirstVideoFromStore], function (selectedVideoId, featuredVideoId, firstVideoId) {
    return selectedVideoId || featuredVideoId || firstVideoId;
});
//# sourceMappingURL=selected-video-id.js.map